'use strict';

angular.module('cvsApp').controller('ReviewPaymentsCtrl', ["$scope", "$state", "userSession", 'doPaymentService', '$stateParams', 'addDataService', 'webAnalytics', '$http', "commonService", "$sce", "$timeout", "$filter", "errorModel", "loggerService", "loggerServiceHelper",
  function ($scope, $state, UserSession, doPaymentService, $stateParams, addDataService, webAnalytics, $http, commonService, $sce, $timeout, $filter, EM, loggerService, loggerServiceHelper) {
    console.log("see, it's review payment page",UserSession);
    $scope.content = wcmContent;

    var log = loggerService(loggerServiceHelper.setCategory(CVSLOGHELPER.CATEGORY.PAYMENT_REGISTERED) + loggerServiceHelper.setFlowType(UserSession.paymentType) + loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.PaymentReview));
    log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.START));

    /*Scroll to top*/
    cvsUtility.genralPostMessage("SCROLL_TO", {
      "scroll": true
    });
    if (!UserSession.paymentAmount) {
      UserSession.paymentAmount = UserSession.accountData.currentBalance;
    }

     /* GST-2088 :In review Payments temporarily disable ACH disclosure link for only mobile app in Android and IOS */
     $scope.hideAchDisclosure = function () {
      if (cvsUtility.getPlatform() === 'mapp') {
        return false;
      }
      return true;
    }

    $scope.showchDiscOnlyApp = function () {
      if (cvsUtility.getPlatform() === 'mapp') {
        return true;
      }
      return false;
    }

    /**
     * viswa 03/27/2020 - GST-167 UI - Create Tags for Review Payment
     * Added WTS pagename tag for guest and logged in page name is same
     */
    var utagObj = {};
    // if (self == top) { utagObj = { pagename: "PAYMENT-ReviewPayment" }; }

    if (UserSession.paymentType) {
      var paymethod;
      if (UserSession.paymentType == 'full') {
        paymethod = 'full payment';
      } else if (UserSession.paymentType == 'partial') {
        paymethod = 'partial payment';
      } else if (UserSession.paymentType == 'auto') {
        paymethod = 'recurring payment';
      }
      utagObj.paymenttype = paymethod;

    }

    if (UserSession.registered) {
      if ($scope.session.paymentType == "auto") {
        webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "reviewAutoPayments");
      } else {
        webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "reviewOnetimePayment");
      }
    } else {

      webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "reviewOnetimePayment");
      // webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "guestReviewPayment");
    }


    $scope.validation = {
      termsCbChecked: false,
      achCbChecked: false,
      formSubmitAttempt: false
    };
    $scope.termsError = function () {
      return $scope.validation && $scope.validation.formSubmitAttempt && !$scope.validation.termsCbChecked;
    };
    $scope.achError = function () {
      return $scope.validation.formSubmitAttempt && !$scope.validation.achCbChecked;
    };

    $scope.selectTerm = function () {
      $timeout(function () {
        document.getElementById("acknowledgeBalance").focus();
        document.getElementById("acknowledgeBalance").scrollIntoView({ behavior: 'smooth' });
      }, 300);
    };

    $scope.selectACH = function () {
      //removed as part of the defect DE54176
      
    };

    $timeout(function () {
      $("#selectaCheckTerm").keyup(function (event) {
        if (event.keyCode === 13) {
          $("#selectaCheckTerm").click();
        }
      });

      $("#selectaCheckAch").keyup(function (event) {
        if (event.keyCode === 13) {
          $("#selectaCheckAch").click();
        }
      });
    }, 300);

    function checkboxBannerFocus(){
      //removed as part of the defect DE54176
    }

    $scope.focustextscrollbox = function () {
      ////removed as part of the defect DE54176
      
    }
    if ($scope.session.accountData.getMopById($scope.session.selectedPaymentMethod)) {
      $scope.paymentMethodType = $scope.session.accountData.getMopById($scope.session.selectedPaymentMethod).payment.method;
    } else {
      $scope.paymentMethodType = addDataService.getNewMOP();
    }

    var paymentDetails = angular.copy($scope.session.accountData.getMopById($scope.session.selectedPaymentMethod));


    if ((UserSession.paymentType === 'auto') && $scope.paymentMethodType == "CCARD" && paymentDetails.transactionMode == "ADD" && localStorage.getItem("autoPayMode") === "ADD") {
      UserSession.autoPay.schedule = 0;
    } else if ((UserSession.paymentType === 'auto') && $scope.paymentMethodType == "CHECK" && paymentDetails.transactionMode == "ADD" && localStorage.getItem("autoPayMode") === "ADD") {
      UserSession.reviewPageAutoPay.limit = angular.copy($scope.session.paymentAmount);
      var date = moment().add(1, 'd').date();
      UserSession.autoPay.schedule = date;
    }
    /*
     * GST-1768 PROD BUG UI: Review Payments Screen, Remove the Save print this ACH disclosure link
     */
    // $scope.printDocument = function () {
    //   /*$http.get('../payments/data/ach_disclousre.pdf').then(function(doc){
    //    doc.print();
    //    });*/
    //    var doc = window.open('../payments/app/images/ach_disclousre.pdf');
    //    doc.print();

    //   log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setDescription("print/save ACH disclosure"));
    // };
    var formData = angular.copy($scope.session.accountData.getMopById($scope.session.selectedPaymentMethod));

    $scope.submitPayment = function () {

      /**
       * sankar 12/16/2016 - ITPR017031 - payment added payment tags
       * Added WTS spx_payment_method, paymnttype, spx_recurring_payment_freq tag
       */
      // if(paymentDetails && paymentDetails.payment && paymentDetails.payment.method && UserSession.paymentType){

      //     var filteredPaymentMethod = $filter('friendlyMopLabel')(paymentDetails.payment.method);
      //     var paymethod;
      //     if(UserSession.paymentType == 'full'){
      //         paymethod = 'Full Payment';
      //     }else if(UserSession.paymentType == 'partial'){
      //         paymethod = 'Partial Payment';
      //     }else if(UserSession.paymentType == 'auto'){
      //         paymethod = 'Recurring Payment';
      //     }
      //     if(UserSession.paymentType === 'auto'){
      //       var frequency = 'MONTHLY';
      //     }
      //      var utagObj = {};
      //     utagObj.spx_payment_method = filteredPaymentMethod;
      //     utagObj.paymenttype = paymethod;
      //     if(frequency){
      //       utagObj.spx_recurring_payment_freq = frequency;
      //     }
      //     webAnalytics.webTrendsUtag("OBJ",utagObj,undefined);
      // }

      /*Setting all error false on initial submit*/
      $scope.SPECIFIC_ERROR = false;
      $scope.ENCRYPTION_ERROR = false;
      $scope.SERVER_ERROR = false;
      $scope.submitPaymentValidataion = false;
      $scope.visaCardValidataion = false;
      $scope.isDisabled = true;
      /*END Setting all error false on initial submit*/
      $scope.validation.formSubmitAttempt = true;
      if ($scope.validation.termsCbChecked === false) {
        checkboxBannerFocus();
        return;
      }

      if ($scope.validation.achCbChecked === false && $scope.paymentMethodType === "CHECK") {
        checkboxBannerFocus();
        return;
      }

      if (!UserSession.registered) {
        formData.transactionMode = "ADD";
      } else if (!formData.transactionMode) {
        formData.transactionMode = "NONE";
      }
      if ($scope.session.paymentType) {
        formData.payment.type = $scope.session.paymentType && $scope.session.paymentType == "auto" ? "RECURRING" : "ONETIME";
      } else {
        formData.payment.type = formData.payment.type && (formData.payment.type == "auto" || formData.payment.type == "RECURRING") ? "RECURRING" : "ONETIME";
      }
      formData.createdBy = "DIGITAL WEB";
      formData.paymentCurrency = "";
      if ($scope.session.paymentType == "auto") {
        formData.payment.amount = $scope.session.reviewPageAutoPay.limit;
      } else {
        formData.payment.amount = $scope.session.paymentAmount;
      }

      formData.billingAddress = $scope.session.accountData.getMopById($scope.session.selectedPaymentMethod).billingAddress;
      // integration and handle Success or Error response.
      if (UserSession.paymentType === 'full') {
        formData.paymentIndicator = "FULL";
      }
      if (UserSession.paymentType === 'partial') {
        formData.paymentIndicator = "PARTIAL";
      }
      if (UserSession.paymentType === 'auto') {
        formData.paymentIndicator = "FULL";
      }
      formData.componentID = cvsUtility.componentName() ? cvsUtility.componentName() : "OLP"; //cvsUtility.queryMap.FromQuickRegistration?"QR":"OLP";

      formData.fastIndicator = "Yes";
      if ($scope.paymentMethodType == "CHECK") {
        formData.achAcceptanceInd = "true"
      } else {
        formData.achAcceptanceInd = "";
      }

      if (formData.transactionMode == 'ADD') {
        //var t0 = performance.now();
        var accountNumber = commonService.getEncryptedRSAData(formData.accountNumber);
        //var t1 = performance.now();
        if (!accountNumber || accountNumber == formData.accountNumber) {
          $scope.ENCRYPTION_ERROR = true;
          /*Scroll to top*/
          cvsUtility.genralPostMessage("SCROLL_TO", {
            "scroll": true
          });
          log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep("EncryptionValidation") + loggerServiceHelper.setDescription("Encryption Error"));
          return;
        } else {
          formData.encryptedAccountNumber = accountNumber;
        }
      }

      $('#specialtySpinner').show();
      $scope.submittingpayment = true;
      log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallStart) + loggerServiceHelper.setServiceName("submitPayment") + loggerServiceHelper.setDescription("flow type - " + formData.payment.type + " ;mode of payment " + formData.paymentIndicator + " ;payment method type " + $scope.paymentMethodType));
      /**
       * START:  service call for Submit payment service 
       */
      doPaymentService.doPayment(formData, callbackSubmitPaymentSuccess, UserSession.guestTokenID);

      function callbackSubmitPaymentSuccess(data) {

        $('#specialtySpinner').hide();

        if (data.SERVER_ERROR) {
          $scope.SERVER_ERROR = true;
          EM.setRefId(data.SERVER_ERROR ? data.SERVER_STATUS : data.apiResponse.showError.refId);
          /** Tagging */
          var utagObj = {};
          utagObj.link_name = "Custom: Review: Submit Payment Error";
          if (UserSession && UserSession.paymentType == 'auto') {
            utagObj.link_name = "Custom: Review Auto: Submit Payment Error";
          }
          var pageError = cvsUtility.getPageError(data, 'Fatal', 'submitPayment');
          utagObj.page_error = pageError;
          webAnalytics.webTrendsUtag("LINK", utagObj, undefined);
          /** logging */
          if (log && log.error) {
            log.error(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
              loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) +
              loggerServiceHelper.setServiceName("submitPayment") +
              loggerServiceHelper.setStatus("ERROR") +
              loggerServiceHelper.setDescription("connection error " + data.SERVER_STATUS + " -- " + data.SERVER_DESC) +
              loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
          }
          return;
        }

        if (data.getError() === '' || !data.apiResponse.showError) {
          /** Tagging */
          var utagObj = {};
          utagObj.link_name = "Custom: Review: Submit Payment";
          utagObj.link_trackvars = "events";
          utagObj.link_trackevents = "event00";
          if (UserSession && UserSession.paymentType == 'auto') {
            utagObj.link_name = "Custom: Review Auto: Submit Payment";
          }
          webAnalytics.webTrendsUtag("LINK", utagObj, undefined);
          /** logging */
          if (log && log.info) {
            log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
              loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) +
              loggerServiceHelper.setServiceName("submitPayment") +
              loggerServiceHelper.setStatus("SUCCESS") +
              loggerServiceHelper.setStatusCode(statusCode) +
              loggerServiceHelper.setDescription("refId: " + $filter('formatRefId')(data.getError().refId, "3")) +
              loggerServiceHelper.setDescription("statusDesc" + data.apiResponse.response.header.statusDesc) +
              loggerServiceHelper.setDescription("sbt pmt full refId:" + data.getError().refId) + 
              loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
          }
          $state.go("confirm-payments");
          addDataService.removeEditedModeStarted();
        } else {
          var header = data.getHeader();
          var statusCode = header.statusCode;
          /** Tagging */
          var utagObj = {};
          utagObj.link_name = "Custom: srx: review payment: error";
          if (UserSession && UserSession.paymentType == 'auto') {
            utagObj.link_name = "Custom: srx: review auto payment: error";
          }
          var pageError = cvsUtility.getPageError(data, 'Fatal', 'submitPayment');
          utagObj.page_error = pageError;
          webAnalytics.webTrendsUtag("LINK", utagObj, undefined);

          switch (statusCode) {
            case 'MAKE_PMT_021': {
              /* GST-149 UI - Display error message on the 'Review Payment' page when the Visa card real-time validation failed */
              var statusCode = data.apiResponse.showError.statusCode;
              $scope.visaCardValidataion = true;
              $scope.submittingpayment = false;
              setTimeout(function () {
                document.getElementById('paymentcardErrorBlock').focus();
                document.getElementById("paymentcardErrorBlock").scrollIntoView({
                  behavior: 'smooth'
                });
              }, 100);
              /* logging */
              if (log && log.error) {
                log.error(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
                  loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) +
                  loggerServiceHelper.setServiceName("submitPayment") +
                  loggerServiceHelper.setStatus("ERROR") + 
                  loggerServiceHelper.setStatusCode(statusCode) +
                  loggerServiceHelper.setDescription("refId: " + $filter('formatRefId')(data.getError().refId, "3")) +
                  loggerServiceHelper.setDescription("statusDesc" + data.apiResponse.response.header.statusDesc) +
                  loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) +
                  loggerServiceHelper.setDescription("sbt pmt full refId:" + data.getError().refId));
              }
              break;
            }
            default: {
              var statusCode = data.apiResponse.showError.statusCode;
              if (statusCode) {
                setErrorMessage(statusCode);
              }
              EM.setRefId(data.SERVER_ERROR ? data.SERVER_STATUS : data.apiResponse.showError.refId);
              /* logging */
              if (log && log.error) {
                log.error(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
                  loggerServiceHelper.setServiceName("submitPayment") +
                  loggerServiceHelper.setStatus("ERROR") + 
                  loggerServiceHelper.setStatusCode(statusCode) +
                  loggerServiceHelper.setDescription("refId: " + $filter('formatRefId')(data.getError().refId, "3")) +
                  loggerServiceHelper.setDescription("statusDesc" + data.apiResponse.response.header.statusDesc) +
                  loggerServiceHelper.setDescription("sbt pmt full refId:" + data.getError().refId) +
                  loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
              }
              break;
            }
          }
        }
        localStorage.clear();
        Object.keys(UserSession.persit).forEach(function (key) {
          delete UserSession.persit[key];
        });
      }

      // $scope.isDisabled = true;
    }; 
    $scope.lastFour = $scope.session.accountData.getMopById($scope.session.selectedPaymentMethod).accountNumber ? $filter('lastFour')($scope.session.accountData.getMopById($scope.session.selectedPaymentMethod).accountNumber) : ""
    var ordinal = $filter('ordinal')(moment().date(UserSession.autoPay.schedule).add(1, "M").format("D"));

    $scope.pdfContent = angular.copy($scope.content);
    var recurringPdfContent = ".\n";
    if ($scope.session.paymentType == "auto") {
      recurringPdfContent = " " + $scope.content.specialty_help.authorize_pdf_para_three + " " + ordinal + " " + $scope.content.specialty_help.authorize_pdf_para_four + $scope.session.reviewPageAutoPay.limit + '.\n\n' + $scope.content.specialty_help.authorize_pdf_para_five;
    }
    $scope.autorecurringPdfContent = "\n";
    if ($scope.session.paymentType == "auto") {
      $scope.autorecurringPdfContent = "\n" + $scope.content.specialty_help.ach_pdf_autopayment_amount_1  + "\n " + $scope.content.specialty_help.ach_pdf_autopayment_amount_2 + $scope.session.reviewPageAutoPay.limit;
    }
    $scope.autorecurringchargesPdfContent = ".";
    $scope.isDiabledmappautocontenttext = false;
    if ($scope.session.paymentType == "auto") {
      $scope.isDiabledmappautocontenttext = true;
      $scope.autorecurringchargesPdfContent = ' ' + $scope.content.specialty_help.ach_pdf_para_five_3 + $scope.session.reviewPageAutoPay.limit + '.';
    }

    // var dd = {
    //   pageSize: $scope.content.specialty_help.pageSize,
    //   content: [{
    //       text: $scope.content.specialty_help.Disclaimer,
    //       style: ['header', 'aligncenter']
    //     },
    //     $scope.content.generalContent.new_line,
    //     $scope.content.specialty_help.authorize_pdf_para_one + $scope.content.generalContent.new_line + $scope.content.generalContent.new_line,
    //     $scope.content.specialty_help.authorize_pdf_para_two + $scope.session.paymentAmount + recurringPdfContent
    //     /* $scope.content.generalContent.authorize_pdf_para_three + ordinal + $scope.content.generalContent.authorize_pdf_para_four + $scope.session.reviewPageAutoPay.limit + ' \n\n',
    //      $scope.content.generalContent.authorize_pdf_para_five*/
    //     , $scope.content.generalContent.new_line + $scope.content.specialty_help.authorize_pdf_para_six + " " + $scope.content.specialty_help.corporate_address +
    //     /*formData.billingAddress.addressLine1 + ", " + formData.billingAddress.city + ", " + formData.billingAddress.state + ", " + formData.billingAddress.zipCode +*/
    //     " " + $scope.content.specialty_help.authorize_pdf_para_seven + $scope.content.generalContent.new_line + $scope.content.generalContent.new_line, {
    //       text: $scope.content.specialty_help.bank_acc_ending + " " + lastFour + ".",
    //       style: 'center'
    //     },
    //     '\n'
    //     /*,
    //             $scope.content.generalContent.authorize_pdf_para_eight*/
    //     , {
    //       text: $scope.content.specialty_help.printed_on + (new Date()).toUTCString(),
    //       style: ['quote', 'small']
    //     }

    var dd = {
      pageSize: $scope.content.specialty_help.pageSize,
      content: [{
        text: $scope.content.specialty_help.ach_Disclaimer,
        style: ['header', 'aligncenter']
      },
      $scope.content.generalContent.new_line,
      $scope.content.specialty_help.ach_pdf_payment_info_1,
      {
        text: $scope.content.specialty_help.ach_pdf_payment_info_2 + '' + $scope.lastFour,
        bold: true
      },
      $scope.content.generalContent.new_line,
      $scope.content.specialty_help.ach_pdf_payment_amount_1,
      {
        text: $scope.content.specialty_help.ach_pdf_payment_amount_2 + '' + $scope.session.paymentAmount,
        bold: true

      },
      $scope.autorecurringPdfContent,
      $scope.content.generalContent.new_line,
      $scope.content.specialty_help.ach_pdf_contact_info_1,
      $scope.content.specialty_help.ach_pdf_contact_info_2,
      {
        text: $scope.content.specialty_help.ach_pdf_contact_info_3,
        bold: true

      },
      $scope.content.generalContent.new_line,
      {
        text: [
          $scope.content.specialty_help.ach_pdf_para_three_1,
          { text: $scope.content.specialty_help.ach_pdf_para_three_2, bold: true },
          $scope.content.specialty_help.ach_pdf_para_three_3,
          { text: $scope.content.specialty_help.ach_pdf_para_three_4, bold: true },
        ]
      },
      $scope.content.generalContent.new_line,
      $scope.content.specialty_help.ach_pdf_para_four + $scope.content.generalContent.new_line + $scope.content.generalContent.new_line,

      {
        text: [
          $scope.content.specialty_help.ach_pdf_para_five_1,
          { text: $scope.lastFour, bold: true },
          $scope.content.specialty_help.ach_pdf_para_five_2,
          { text: $scope.session.paymentAmount, bold: true },
          $scope.autorecurringchargesPdfContent,
          $scope.content.specialty_help.ach_pdf_para_five_4
        ]
      },
      $scope.content.generalContent.new_line,
      $scope.content.specialty_help.ach_pdf_para_six + $scope.content.generalContent.new_line + $scope.content.generalContent.new_line,
      $scope.content.specialty_help.ach_pdf_para_seven + $scope.content.generalContent.new_line + $scope.content.generalContent.new_line,

      {
        text: [
          $scope.content.specialty_help.ach_pdf_para_eight_1,
          { text: $scope.content.specialty_help.ach_pdf_para_eight_2, bold: true },
          $scope.content.specialty_help.ach_pdf_para_eight_3,
          { text: $scope.content.specialty_help.ach_pdf_para_eight_4, bold: true },
          $scope.content.specialty_help.ach_pdf_para_eight_5 + $scope.content.generalContent.new_line + $scope.content.generalContent.new_line,
        ]
      },
      $scope.content.specialty_help.ach_pdf_para_nine + $scope.content.generalContent.new_line + $scope.content.generalContent.new_line,
      $scope.content.specialty_help.ach_pdf_para_ten + $scope.content.generalContent.new_line + $scope.content.generalContent.new_line,
      {
        text: $scope.content.specialty_help.ach_pdf_para_eleven,
        bold: true
      },
      $scope.content.generalContent.new_line,
      {
        text: $scope.content.specialty_help.printed_on + (new Date()).toUTCString(),
        style: ['quote', 'small']
      }
      ],
      styles: {
        header: {
          fontSize: 16,
          bold: true
        },
        subheader: {
          fontSize: 14,
          bold: true
        },
        quote: {
          italics: true
        },
        small: {
          fontSize: 8
        },
        aligncenter: {
          alignment: 'center'
        }
      }
    };

    /*
     * GST-1768 PROD BUG UI: Review Payments Screen, Remove the Save print this ACH disclosure link
     */

    $scope.printDocument = function () {
      if (navigator.userAgent.indexOf('MSIE') !== -1 ||
        navigator.appVersion.indexOf('Trident/') > 0) {
        /* Microsoft Internet Explorer detected in. */
        pdfMake.createPdf(dd).download();
        log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setDescription("print/save ACH disclosure form IE11 "));
      } else {
        pdfMake.createPdf(dd).open();
        log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setDescription("print/save ACH disclosure form"));
      }

    };

    var setErrorMessage = function (errorCode) {
      var errorMessage = wcmContent.errorMessage[errorCode];
      var isDefaultErr = false;
      if (!errorMessage) {

        errorMessage = wcmContent.submitPayV3ErrorMessage[errorCode];
        if(errorMessage){
          $scope.submitPayErrorConfig = errorMessage;
          $scope.submitPaymentValidataion = true;
          setTimeout(function () {
            document.getElementById('paymentSubmitErrorBlock').focus();
            document.getElementById("paymentSubmitErrorBlock").scrollIntoView({
              behavior: 'smooth'
            });
          }, 100);
          $scope.submittingpayment = false;
          return '';
        }else{
          errorMessage = wcmContent.errorMessage.default;
          isDefaultErr = true;
        }
      }
      
      $scope.errorMessageSpecific = {
        alertType: "error",
        title: "",
        message: errorMessage,
        suppressIcon: false,
        contactlink: isDefaultErr ? "Contact Us" : undefined
      };
      $scope.SPECIFIC_ERROR = true;
      $scope.submittingpayment = false;
      cvsUtility.genralPostMessage("SCROLL_TO", {
        "scroll": true
      });
    }
    log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setDescription("Review Payment payment page load completed"));
    setTimeout(function(){
      document.getElementById('review-heading').focus()
    })
  }
]);